import { useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { GetStripeAccountLinkDocument, StripeAccountLinkType } from '../../gql/graphql';
import ProgressPage from '../ProgressPage';
import { useParams } from 'react-router-dom';

export interface StripeAccountRedirectProps {
    type?: StripeAccountLinkType;
}

const StripeAccountRedirect = ({ type: propType }: StripeAccountRedirectProps) => {
    const { type: urlType } = useParams<{ type: string }>();
    
    // Use the type from props if provided, otherwise use the type from the URL
    const type = propType || (urlType === 'ACCOUNT_UPDATE' ? 
        StripeAccountLinkType.AccountUpdate : 
        StripeAccountLinkType.AccountOnboarding);
    
    const { data, loading, error } = useQuery(GetStripeAccountLinkDocument, { 
        variables: { type },
        fetchPolicy: 'network-only'
    });

    // Redirect as a side effect, not during render.
    useEffect(() => {
        const link = data?.stripeAccountLink;
        if (link) {
            if (window.top) {
                window.top.location.href = link;
            } else {
                window.location.href = link;
            }
        }
    }, [data?.stripeAccountLink]);

    if (loading) return <ProgressPage
        title="Redirecting to Stripe..."
        spinner={true}
    />;

    if (error) return <div>Error</div>;

    return null;
};

export default StripeAccountRedirect; 